import { format } from '../format';

/*
 *
 * @param count - количество
 * @param str0 - строка для 1
 * @param str1 - строка для 2-4
 * @param str2 - строка для 5 и более
 * @returns строка с количеством
 *
 * @example pluralize(2, '%d яблоко', '%d яблока', '%d яблок') // '2 яблока'
 */
export function pluralize(count: number, str0: string, str1: string, str2: string): string {
    const formatted = format(count, {
        type: 'number',
    });

    if (count % 10 === 1 && count % 100 !== 11) {
        return str0.replace(/%d/g, formatted);
    }

    if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
        return str1.replace(/%d/g, formatted);
    }

    return str2.replace(/%d/g, formatted);
}
